import * as Types from '../../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateGatewayRoutingMutationVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
  gatewayRoutings: Array<Types.InputMaybe<Types.GatewayRouting>>;
}>;


export type UpdateGatewayRoutingMutation = { __typename?: 'Mutation', updateGatewayRouting?: { __typename?: 'MutationResult', errors?: Array<{ __typename?: 'Error', location: Array<string>, type: string, context?: string | null }> | null } | null };


export const UpdateGatewayRoutingDocument = gql`
    mutation updateGatewayRouting($domainId: Int!, $gatewayRoutings: [GatewayRouting]!) {
  updateGatewayRouting(domainId: $domainId, gatewayRoutings: $gatewayRoutings) {
    errors {
      location
      type
      context
    }
  }
}
    `;
export type UpdateGatewayRoutingMutationFn = Apollo.MutationFunction<UpdateGatewayRoutingMutation, UpdateGatewayRoutingMutationVariables>;

/**
 * __useUpdateGatewayRoutingMutation__
 *
 * To run a mutation, you first call `useUpdateGatewayRoutingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGatewayRoutingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGatewayRoutingMutation, { data, loading, error }] = useUpdateGatewayRoutingMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      gatewayRoutings: // value for 'gatewayRoutings'
 *   },
 * });
 */
export function useUpdateGatewayRoutingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGatewayRoutingMutation, UpdateGatewayRoutingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGatewayRoutingMutation, UpdateGatewayRoutingMutationVariables>(UpdateGatewayRoutingDocument, options);
      }
export type UpdateGatewayRoutingMutationHookResult = ReturnType<typeof useUpdateGatewayRoutingMutation>;
export type UpdateGatewayRoutingMutationResult = Apollo.MutationResult<UpdateGatewayRoutingMutation>;
export type UpdateGatewayRoutingMutationOptions = Apollo.BaseMutationOptions<UpdateGatewayRoutingMutation, UpdateGatewayRoutingMutationVariables>;